export default "__VITE_ASSET__LWrkDeAx__"